import React from 'react';
import { Field } from 'formik';
import { useQuery } from '@apollo/client';
import Loader from 'components/common/Loader';
import ReactSelect from 'components/Fields/ReactSelect';
import { COUPONS_QUERY } from 'pages/OfferCoupons/CouponGraphQL';

const CouponCodeField = ({ filter = [], ...props }) => {
  const { data, loading, error } = useQuery(COUPONS_QUERY, {
    variables: {
      filter: [
        {
          key: 'status',
          value: 'ACTIVE',
          type: 'BOOLEAN',
          op: 'EQ',
        },
        ...filter,
      ],
      pagination: false,
    },
    fetchPolicy: 'network-only',
  });

  if (loading) return <Loader />;
  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <div>
      {' '}
      <Field
        data={data?.coupons?.coupons || []}
        component={ReactSelect}
        keys={{ id: 'id', label: 'label' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.code}
        {...props}
      />
    </div>
  );
};

export default CouponCodeField;
